export interface DiffCell {
  value: unknown;
  expected: unknown;
  matches: boolean;
}
export interface DiffRow {
  cells: Record<string, DiffCell>;
}

/**
 * Row-index-aligned diff for display purposes only (NOT the grading
 * comparator — CompareResultSet on the backend is the source of truth for
 * AC/WA and is order-insensitive; this is purely a "here's what differed"
 * visualization, so a simple positional diff is fine even though it may not
 * exactly explain an order-insensitive backend match/mismatch in every case).
 */
export function diffRowSets(actual: unknown[], expected: unknown[]): DiffRow[] {
  const rowCount = Math.max(actual.length, expected.length);
  const rows: DiffRow[] = [];
  for (let i = 0; i < rowCount; i++) {
    const a = (actual[i] ?? {}) as Record<string, unknown>;
    const e = (expected[i] ?? {}) as Record<string, unknown>;
    const keys = new Set([...Object.keys(a), ...Object.keys(e)]);
    const cells: Record<string, DiffCell> = {};
    for (const key of keys) {
      cells[key] = {
        value: a[key],
        expected: e[key],
        matches: JSON.stringify(a[key]) === JSON.stringify(e[key]),
      };
    }
    rows.push({ cells });
  }
  return rows;
}

/** Attempts to parse a case-result string as a JSON array of row objects. */
export function tryParseRowSet(s: string): Record<string, unknown>[] | null {
  try {
    const parsed = JSON.parse(s);
    return Array.isArray(parsed) ? parsed : null;
  } catch {
    return null;
  }
}
